export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/@ant-design/icons-react/es/index.js
// module id = 255
// module chunks = 20